<!--
 * @Description: 平台管理
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-01-29 10:51:17
 * @LastEditors: @Xin (834529118@qq.com)
 * @LastEditTime: 2021-10-27 11:15:10
 -->
<template>
  <div class="platformMana">
    <div class="searchContainer">
      <div class="searchItem">
        <span class="searchTitle">平台名称：</span>
        <el-select v-model="platformId" clearable placeholder="请选择系统">
          <el-option
            v-for="item in platformData"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="searchItem">
        <span class="searchTitle">资源状态：</span>
        <el-select v-model="searchState" clearable :disabled="dialogType === 'detail'" placeholder="请选择启用状态">
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-button class="searchButton" type="primary" round @click="search">查询</el-button>
    </div>
    <div class="listContainer">
      <div class="topInfo">
        <div class="listTitle">资源定义</div>
        <div class="handleArea">
          <el-button class="addButton" type="danger" round @click="add">新增</el-button>
        </div>
      </div>
      <div class="list">
        <el-table
          :data="listData">
          <el-table-column
            align="center"
            prop="platformName"
            label="所属平台">
          </el-table-column>
          <el-table-column
            align="center"
            prop="descr"
            label="资源名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="method"
            label="资源code">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stateName"
            label="平台状态">
          </el-table-column>
          <el-table-column
            align="center"
            width="260"
            v-slot="{row}"
            label="操作">
            <div class="handle">
              <span class="detail" @click='showDetail(row)'>详情</span>
              <span class="modify" @click='modify(row)'>编辑</span>
              <span class="delete" @click='deleteHandle(row)'>删除</span>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <BasePagination
          :total="total"
          :page-size="pageSize"
          :current-page="pageIndex"
          background
          @pagination="currentChange"
        />
      </div>
    </div>
    <!-- 新增平台 弹框 start -->
    <el-dialog
      class="addUserDialog"
      @closed="addDialogClosed"
      :title="addDialogTitle"
      :visible.sync="addDialogVisible">
      <div class="content">
        <!-- <div class="userInfoItem">
          <span class="title">平台代码：</span>
          <el-input v-model="code" :disabled="dialogType === 'detail'" placeholder="请输入平台代码"></el-input>
        </div> -->
        <div class="userInfoItem">
          <span class="title">所属平台：</span>
          <el-select v-model="addData.platformId" clearable :disabled="dialogType === 'detail'" placeholder="默认为全平台应用">
            <el-option
              v-for="item in platformData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="userInfoItem">
          <span class="title">资源名称：</span>
          <el-input v-model="addData.descr" :disabled="dialogType === 'detail'" placeholder="请输入资源名称"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">资源code：</span>
          <el-input v-model="addData.method" :disabled="dialogType === 'detail'" placeholder="请输入资源code"></el-input>
        </div>
        <div class="userInfoItem">
          <span class="title">启用状态：</span>
          <el-select v-model="addData.state" :disabled="dialogType === 'detail'" placeholder="请选择启用状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="handleArea" v-if="dialogType !== 'detail'">
          <el-button type="danger" size="medium" @click="cancelDetailDialog">取消</el-button>
          <el-button type="primary" size="medium" @click="confirmDetailDialog">{{dialogType === 'modify' ? '修改' : '新增'}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增平台 弹框 end -->
  </div>
</template>

<script>
import BasePagination from '@/components/BasePagination'
import { mapMutations } from 'vuex'

export default {
  name: 'platformMana',
  components: {
    BasePagination,
  },
  data () {
    return {
      platformData: [],
      platformId: null,
      dialogType: '',
      // 新增平台参数start
      addData: {
        id: null,
        descr: null,
        platformId: null,
        method: null,
        state: true,
      },
      scanLogin: '',
      // 新增平台参数end
      // 平台状态配置项
      stateOptions: [
        {
          value: true,
          label: '启用',
        },
        {
          value: false,
          label: '禁用',
        },
      ],
      addDialogVisible: false,
      addDialogTitle: '',
      searchState: null,
      // 列表数据
      listData: [],
      // 分页信息
      pageIndex: 1,
      pageSize: 10,
      total: 0,
    }
  },
  methods: {
    ...mapMutations([
      'setGlobalPlatformSelecter',
    ]),
    /**
     * @description             获取平台树形数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    getPlatformTree () {
      return this.$http.get('/api/platform/all')
        .then(res => {
          if (res.code === 'success') {
            this.platformData = res.data.list || []
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    search () {
      this.pageIndex = 1
      this.initListData()
    },
    /**
     * @description             详情
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    showDetail (row) {
      Object.keys(this.addData).forEach(k => {
        this.addData[k] = row[k]
      })
      this.addData.platformId = row.findPlatform.id
      this.dialogType = 'detail'
      this.addDialogTitle = '平台详情'
      this.addDialogVisible = true
    },
    /**
     * @description             删除平台按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    deleteHandle (row) {
      this.$confirm('是否删除该资源数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let params = {
          ids: row.id,
        }
        this.$http.post('/api/resource-method/delete', params)
          .then(res => {
            if (res.code === 'success') {
              this.$notify({
                message: '删除成功！',
                type: 'success',
              })
              this.initListData()
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    /**
     * @description             新增用户按钮
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    add () {
      this.dialogType = 'add'
      this.addData.id = null
      this.addDialogTitle = '新增平台'
      this.addDialogVisible = true
    },
    /**
     * @description             修改用户按钮
     * @param {Object}          用户信息
     * @return {undefined}      无返回值
     */
    modify (row) {
      Object.keys(this.addData).forEach(k => {
        this.addData[k] = row[k]
      })
      this.addData.platformId = row.findPlatform.id
      this.dialogType = 'modify'
      this.addDialogTitle = '平台修改'
      this.addDialogVisible = true
    },
    /**
     * @description             置空用户信息
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    clearInfo () {
      Object.keys(this.addData).forEach(k => {
        this.addData[k] = null
      })
      this.addData.state = true
    },
    /**
     * @description             取消新增或修改
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    cancelDetailDialog () {
      this.addDialogVisible = false
    },
    /**
     * @description             确认新增或修改
     * @param {undefined}       新增时：无
     * @param {id}              修改时：id
     * @return {undefined}      无返回值
     */
    confirmDetailDialog () {
      const { id, ...rest } = this.addData
      const params = { ...rest }
      id && (params.id = id)

      this.$http.post('/api/resource-method/save', params)
        .then(res => {
          if (res.code === 'success') {
            this.addDialogVisible = false
            this.$notify({
              message: this.dialogType === 'modify' ? '修改成功！' : '新增成功！',
              type: 'success',
            })
            this.initListData()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description             详情框关闭时的回调
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    addDialogClosed () {
      this.clearInfo()
    },
    /**
     * @description             初始化列表数据
     * @param {undefined}       无
     * @return {undefined}      无返回值
     */
    initListData () {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        platformId: this.platformId || null,
        state: this.searchState === '' ? null : this.searchState,
      }
      this.$http.get('/api/resource-method/list', params)
        .then(res => {
          if (res.code === 'success') {
            this.listData = res.data.list.map(({ platformId, state, ...rest }) => {
              const findStatus = this.stateOptions.find(({ value }) => value === state) || {}
              const findPlatform = !platformId ? { name: '全平台' } : this.platformData.find(({ id }) => id === platformId) || {}

              return {
                state,
                stateName: findStatus.label,
                platformName: findPlatform.name,
                findPlatform,
                ...rest,
              }
            })
            this.pageIndex = res.data.pageIndex
            this.total = res.data.total
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
    /**
     * @description: 当前页change事件
     * @param {Object} 事件对象
     * @return {undefined} 无返回值
     */
    currentChange (e) {
      this.pageIndex = e
      this.initListData()
    },
  },
  async created () {
    this.setGlobalPlatformSelecter(false)
    await this.getPlatformTree()
    this.initListData()
  },
}
</script>

<style lang="less" scoped>
  .platformMana{
    width: 100%;
    height: 100%;

    .searchContainer {
      width: calc(100% - 40px);
      height: 50px;
      padding: 0 20px;
      position: relative;
      border-bottom: 1px solid rgb(241, 239, 239);

      .searchItem {
        display: inline-block;
        margin-right: 40px;
        .searchTitle {
          color: #666;
        }
        .el-input {
          width: 200px;
        }
      }

      .searchButton {
        float: right;
      }
    }

    .listContainer {
      width: 100%;
      height: calc(100% - 50px);

      .topInfo {
        width: calc(100% - 40px);
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        .listTitle {
          font-size: 26px;
          font-weight: bold;
        }
      }

      .list {
        /deep/.el-table {
          .el-table__body-wrapper {
            .el-table__body {
              tbody {
                tr {
                  td {
                    padding: 18px 0;
                  }
                }
              }
            }
          }
        }
        .abnormal {
          color: #F56C6C;
        }
        .normal {
          color: #67C23A;
        }
        .handle{
          span {
            display: inline-block;
            width: 40px;
            text-decoration: underline;
            cursor: pointer;
          }
          .detail {
            color: #3890f2;
          }
          .enable {
            color: #67C23A;
          }
          .disable {
            color: #F56C6C;
          }
          .modify{
            color: #3890f2;
          }
          .modifyPassword {
            color: #3890f2;
            width: 70px;
          }
          .delete{
            color: #F56C6C;
          }
        }
      }

      .pagination {
        text-align: center;
        padding: 40px 0 0 0;
      }
    }

    /deep/.addUserDialog {
      .el-dialog {
        width: 960px;
        height: 640px;
        border-radius: 6px;
        .el-dialog__header {
          background: #2c63a3;
          border-radius: 6px 6px 0 0;
          padding: 10px 20px;
          .el-dialog__title {
            color: #fff;
          }
          .el-dialog__headerbtn {
            top: 10px;
            .el-dialog__close {
              color: #fff;
              font-size: 26px;
            }
          }
        }
        .el-dialog__body {
          height: calc(100% - 84px);
          padding: 20px;
          .content {
            width: 100%;
            height: 100%;
            position: relative;
            .userInfoItem {
              display: inline-block;
              width: 40%;
              margin: 30px 5%;
              .title {
                display: inline-block;
                width: 80px;
              }
              .el-input {
                width: 220px;
              }
            }

            .handleArea {
              text-align: right;
              position: absolute;
              bottom: 30px;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>
